export function isSalaAtiva(ativo) {
  return ativo !== 0 && ativo !== false && ativo !== '0';
}

export const SALA_STATUS_LABELS = {
  waiting: 'Aguardando',
  active: 'Ativa',
  closing: 'Encerrando',
  closed: 'Encerrada'
};

export function formatSalaStatus(estado) {
  if (!estado) {
    return 'Não informado';
  }

  const key = String(estado).trim().toLowerCase();
  return SALA_STATUS_LABELS[key] || String(estado);
}

export function isParticipanteNaSala(naSala, uid) {
  if (naSala == null || uid == null || uid === '') return false;

  const present = String(naSala).trim();
  const expected = String(uid).trim();

  if (!present || present === '0' || /^0+$/.test(present)) return false;

  return present === expected;
}

export function resolveSalaEstado(sala) {
  const primarioPresente = isParticipanteNaSala(sala?.primarioNaSala, sala?.uidPrimario);
  const secundarioPresente = isParticipanteNaSala(sala?.secundarioNaSala, sala?.uidSecundario);

  if (primarioPresente && secundarioPresente) return 'active';

  if (primarioPresente || secundarioPresente) return 'waiting';

  const estado = String(sala?.estadoNome || sala?.estado || '')
    .trim()
    .toLowerCase();

  if (SALA_STATUS_LABELS[estado]) return estado;

  return isSalaAtiva(sala?.ativo) ? 'waiting' : 'closed';
}

export function formatDate(value) {
  if (!value) {
    return 'Não informado';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString('pt-BR');
}

export function formatDateOnly(value) {
  if (!value) {
    return 'Não informado';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleDateString('pt-BR');
}

export function formatTimeOnly(value) {
  if (!value) {
    return 'Não informado';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

export function formatDuration(ms) {
  const totalMs = Number(ms) || 0;
  if (totalMs <= 0) {
    return '—';
  }

  const totalSeconds = Math.floor(totalMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}min ${String(seconds).padStart(2, '0')}s`;
}

export function formatClienteLabel(sala) {
  const nome = sala?.clienteNome || sala?.cliente;
  const codigo = sala?.clienteCodigo;

  if (nome && codigo) {
    return `${nome} (${codigo})`;
  }

  if (nome) {
    return String(nome);
  }

  if (codigo) {
    return String(codigo);
  }

  return 'Não informado';
}

export function withClienteColumn(columns, isAdmin) {
  if (!isAdmin) {
    return columns;
  }

  return [{ key: 'cliente', label: 'Cliente' }, ...columns];
}

export function mapSalaRow(sala) {
  const secundarioPresente = isParticipanteNaSala(sala.secundarioNaSala, sala.uidSecundario);
  const status = formatSalaStatus(resolveSalaEstado(sala));

  return {
    id: sala.id,
    protocolo: sala.nome || 'Não informado',
    cliente: formatClienteLabel(sala),
    idClientes: sala.idClientes,
    primario: sala.uidPrimario || 'Não informado',
    nomePrimario: sala.nomePrimario || 'Não informado',
    nivelTransmissaoPrimario: status,
    nivelTransmissao: status,
    secundario: sala.uidSecundario || 'Não informado',
    nomeSecundario: sala.nomeSecundario || 'Não informado',
    nivelTransmissaoSecundario: secundarioPresente ? 'Presente' : 'Ausente',
    duracaoEspera: formatDuration(sala.tempoEsperaMs),
    duracaoChamada: formatDuration(sala.duracaoChamadaMs),
    status,
    dataCriacao: formatDateOnly(sala.createdAt),
    horarioCriacao: formatTimeOnly(sala.createdAt),
    atualizadoEm: formatDate(sala.updatedAt),
    criadoEm: formatDate(sala.createdAt),
    ativo: isSalaAtiva(sala.ativo),
    uidPrimario: sala.uidPrimario,
    uidSecundario: sala.uidSecundario,
    raw: sala
  };
}

export function filterSalasBySearch(rows, search) {
  if (!search.trim()) {
    return rows;
  }

  const term = search.toLowerCase().trim();

  return rows.filter((row) => {
    return [
      row.protocolo,
      row.cliente,
      row.primario,
      row.nomePrimario,
      row.secundario,
      row.nomeSecundario,
      row.status,
      row.nivelTransmissao,
      row.nivelTransmissaoPrimario,
      row.nivelTransmissaoSecundario,
      row.duracaoEspera,
      row.duracaoChamada,
      row.dataCriacao,
      row.horarioCriacao,
      row.atualizadoEm,
      row.criadoEm
    ].some((value) => String(value).toLowerCase().includes(term));
  });
}
